import { styled as styledMUI, Box, Paper, Fab } from "@mui/material";

export const ContainerMap = styledMUI(Box)(() => ({
  width: "100%",
  height: "40vh",
  marginBottom: "20px",
}));
